import React from 'react'
import { useParams } from 'react-router'
import { useCity } from '../../hooks/CompanyConfiguration/useCity'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import CityView from '../../components/version-4/viewForms/CityView'
import { ROUTES } from '../../shared/constants'

function ViewCity() {
  const { city, getCity } = useCity()
  const params = useParams()

  React.useEffect(() => {
    getCity({ cityId: params.cityId })
  }, [params.cityId])

  return (
    <Layout heading="City" heading2="Info" url1={ROUTES.CITY} none>
      {city ? (
        <HeaderTabLayout heading="City" content={<CityView city={city} />} view url={`/edit-city/${params.cityId}`} />
      ) : (
        <Loader />
      )}
    </Layout>
  )
}

export default ViewCity
